import { MESSAGE_CHAT_ERASE } from "./Chat_reducer";

const defaultState = {
  shadows: [false, true, true, true, true, true, true, true, true],
  basket: [],
  allSum: 0,
  // deliveryDate: null,
  personalDate: null,
  message: "",
  fetch: false,
  file: null,
};
const HIDDEN_SHADOW = "HIDDEN_SHADOW";
export const hiddenShadow = (payload) => ({ type: HIDDEN_SHADOW, payload });
const SET_CHECK_SUM = "SET_CHECK_SUM";
export const setCheckSum = (payload) => ({ type: SET_CHECK_SUM, payload });
const PLUS_NUMBER_OF_ITEM = "PLUS_NUMBER_OF_ITEM";
export const plusNumberOfItem = (payload) => ({
  type: PLUS_NUMBER_OF_ITEM,
  payload,
});
const MINUS_NUMBER_OF_ITEM = "MINUS_NUMBER_OF_ITEM";
export const minusNumberOfItem = (payload) => ({
  type: MINUS_NUMBER_OF_ITEM,
  payload,
});
const ADD_TO_BASKET = "ADD_TO_BASKET";
export const addToBasket = (payload) => ({ type: ADD_TO_BASKET, payload });
const DELETE_ALL_BASKET = "DELETE_ALL_BASKET";
export const deleteAllBasket = (payload) => ({
  type: DELETE_ALL_BASKET,
  payload,
});
const DELETE_ONE_ITEM_BASKET = "DELETE_ONE_ITEM_BASKET";
export const deleteOneItemBasket = (payload) => ({
  type: DELETE_ONE_ITEM_BASKET,
  payload,
});
export const SEND_MAIL_REQUEST = "SEND_MAIL_REQUEST";
export const sendMailRequest = (payload) => ({
  type: SEND_MAIL_REQUEST,
  payload,
});
const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS";
export const sendMailSuccess = (payload) => ({
  type: SEND_MAIL_SUCCESS,
  payload,
});
const SEND_MAIL_FAILURE = "SEND_MAIL_FAILURE";
export const sendMailFailure = (payload) => ({
  type: SEND_MAIL_FAILURE,
  payload,
});
const ADDITION_ALL_SUM = "ADDITION_ALL_SUM";
export const additionAllSum = (payload) => ({
  type: ADDITION_ALL_SUM,
  payload,
});
/*const SET_DELIVERY_DATE = "SET_DELIVERY_DATE";
export const setDeliveryDate = (payload) => ({
  type: SET_DELIVERY_DATE,
  payload,
});*/

const ADD_FILE = "ADD_FILE";
export const addFile = (payload) => ({ type: ADD_FILE, payload });

function deliverySum(delivery) {
  if (delivery === "МСК") return 3000;
  if (delivery === "МКАД") return 5000;
  return 0;
}

function checkAllSum(basket) {
  const reducer = (previousValue, currentValue) => previousValue + currentValue;
  return basket.map((el) => el.number * el.sum).reduce(reducer);
}

function shadowsControl(shadows, payload) {
  return shadows.map((el, i) => {
    if (i > payload) {
      return true;
    } else if (i === payload && shadows[i - 1] === false) {
      return false;
    } else {
      return el;
    }
  });
}

const Calc_reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SEND_MAIL_REQUEST:
      return {
        ...state,
        fetch: true,
      };
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        fetch: false,
        basket: [],
        allSum: 0,
        deliveryDate: null,
        personalDate: null,
        file: null,
      };
    case SEND_MAIL_FAILURE:
      return {
        ...state,
        fetch: false,
        message: action.payload,
      };
    case MESSAGE_CHAT_ERASE:
      return {
        ...state,
        message: action.payload,
      };
    case HIDDEN_SHADOW: {
      return {
        ...state,
        shadows: shadowsControl(state.shadows, action.payload),
      };
    }
    case ADD_TO_BASKET:
      return {
        ...state,
        basket: [
          ...state.basket,
          Object.assign(action.payload, { sum: state.checkSum, number: 1 }),
        ],
        checkSum: 0,
      };
    case DELETE_ALL_BASKET:
      return {
        ...state,
        file: null,
        basket: [],
      };
    case DELETE_ONE_ITEM_BASKET:
      return {
        ...state,
        basket: state.basket.filter((el) => el !== action.payload),
      };
    case SET_CHECK_SUM:
      return {
        ...state,
        checkSum: action.payload,
      };
    case PLUS_NUMBER_OF_ITEM:
      return {
        ...state,
        basket: state.basket.map((el) => {
          if (el === action.payload) el.number += 1;
          return el;
        }),
      };
    case MINUS_NUMBER_OF_ITEM:
      return {
        ...state,
        basket: state.basket.map((el) => {
          if (el === action.payload && el.number > 1) el.number -= 1;
          return el;
        }),
      };
    case ADDITION_ALL_SUM:
      return {
        ...state,
        allSum:
          checkAllSum(action.payload.basket) +
          deliverySum(action.payload.hasDelivery),
      };
    /*case SET_DELIVERY_DATE:
      return {
        ...state,
        deliveryDate: moment(action?.payload).format("YYYY-MM-DD"),
      };*/
    case ADD_FILE:
      return {
        ...state,
        file: action.payload,
      };
    default:
      return state;
  }
};

export const getShadows = (state) => state.Calc_reducer.shadows;
export const getBasket = (state) => state.Calc_reducer.basket;
export const getCheckSum = (state) => state.Calc_reducer.checkSum;
export const getAllSum = (state) => state.Calc_reducer.allSum;
// export const getDeliveryDate = (state) => state.Calc_reducer.deliveryDate;
export const getFetch = (state) => state.Calc_reducer.fetch;
export const getMessage = (state) => state.Calc_reducer.message;
export const getFile = (state) => state.Calc_reducer.file;

export default Calc_reducer;
